import { useNavigate, useRouteError } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

/**
 * Route-level error boundary. Without one, a single bad property read in a detail page replaces the
 * whole app with react-router's default error screen. Attached to the detail routes (not the shell
 * route) so the sidebar stays mounted and the user can navigate away instead of reloading.
 */
export function RouteErrorPage() {
  const navigate = useNavigate();
  const error = useRouteError();
  const message =
    error instanceof Error
      ? error.message
      : typeof error === 'string'
        ? error
        : 'Unknown error';

  return (
    <div className="flex h-full items-center justify-center p-8">
      <Card className="max-w-md">
        <CardHeader>
          <CardTitle>Couldn&apos;t display this page</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-sm text-muted-foreground">
            Something went wrong while rendering. The rest of the console still works.
          </p>
          <p className="break-words rounded-md bg-muted p-2 font-mono text-xs text-muted-foreground">
            {message}
          </p>
          <div className="flex gap-2">
            <Button size="sm" variant="outline" onClick={() => void navigate(-1)}>
              Go back
            </Button>
            <Button size="sm" variant="ghost" onClick={() => window.location.reload()}>
              Reload
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
